<template>
  <div class="iv-org-target iv-p-t-40 iv-p-b-40">
    <div class="iv-main-width iv-p-b-40">
      <h1 class="iv-fs-24 iv-fc-85 iv-vertical-line iv-m-b-20"><span>组织目标</span></h1>
      <LayoutTitle title="党组织目标" extraInfo="（由党组织关系所在组织定期维护更新）">
        <FormLayout :readOnly="true" :model="partyInfo" :list="baseForm"></FormLayout>
      </LayoutTitle>
      <LayoutTitle class="iv-m-t-24" title="行政组织目标" extraInfo="（由行政关系隶属组织定期维护更新）">
        <FormLayout :readOnly="true" :model="adminInfo" :list="baseForm"></FormLayout>
      </LayoutTitle>
    </div>
    <FooterOperator>
      <div class="iv-text-center">
        <Button type="back" @click="back">返回</Button>
      </div>
    </FooterOperator>
  </div>
</template>

<script>
import baseForm from './base.js'
import Upload from '@/components/upload'
import FormLayout from '@/components/layout/form'
import FooterOperator from '@/components/footer-operator'
import LayoutTitle from '@/components/layout/layout-title'

export default {
  data () {
    return {
      partyInfo: {
        publishOrg: '中共京东方科技集团股份有限公司党委',
        publisher: '杨振',
        publishDate: '2021-1-3',
        orgTarget: '这里是组织近期发布的目标',
        file: ''
      },
      adminInfo: {
        publishOrg: '中共京东方集团',
        publisher: '陈震',
        publishDate: '2021-1-9',
        orgTarget: '这里是组织近期发布的目标',
        file: ''
      }
    }
  },
  created () {
    this.baseForm = baseForm.call(this)
  },
  methods: {
    back () {
      this.$router.push({
        name: 'index'
      })
    }
  },
  components: {
    Upload,
    FormLayout,
    LayoutTitle,
    FooterOperator
  }
}
</script>

<style lang="scss" scoped>
.iv-org-target {
  min-height: 100%;;
  background-color: #fff;
}
</style>
